import { IServicesCard } from 'shared/api/booking/interfaces/services-list.interface';
import { IServiceCategory } from 'shared/api/booking/interfaces/service-categories.interface';

export interface IServiceGroup {
  category: IServiceCategory;
  services: IServicesCard[];
}

export const groupServicesByCategory = (
  services: IServicesCard[],
  categories: IServiceCategory[]
): IServiceGroup[] => {
  return categories
    .map((cat) => ({
      category: cat,
      services: services.filter((s) => s.category?.id === cat.id),
    }))
    .filter((g) => g.services.length > 0);
};

export const getUncategorized = (
  services: IServicesCard[]
): IServicesCard[] => {
  return services.filter((s) => !s.category?.id);
};
